import { queryOptions } from '@tanstack/react-query';
import { api, type TimelineQuery } from '@/api/api';

export const timelineKeys = {
  all: ['timeline'] as const,
  byProject: (projectId: string, query: TimelineQuery = {}) =>
    [...timelineKeys.all, projectId, query] as const,
};

export const timelineOptions = (projectId: string, query: TimelineQuery = {}) =>
  queryOptions({
    queryKey: timelineKeys.byProject(projectId, query),
    queryFn: () => api.getTimeline(projectId, query),
  });

/**
 * Deployment scope — source of truth for `attached_task_ids`.
 *
 * The timeline aggregate (`GET /projects/{id}/timeline`) may omit
 * `attached_task_ids` from its deployment objects, so we fetch the per-epic
 * deployment list separately when the deployment drawer is open.
 */
export const epicDeploymentKeys = {
  all: ['epicDeployments'] as const,
  byEpic: (epicId: string) => [...epicDeploymentKeys.all, epicId] as const,
};

export const epicDeploymentsOptions = (epicId: string) =>
  queryOptions({
    queryKey: epicDeploymentKeys.byEpic(epicId),
    queryFn: () => api.listEpicDeployments(epicId),
  });
